import uuid from 'uuid/v4';

const createProtocol = (session, rows, actions) => {
  const { number, title } = session;
  const protocol = {
    uuid: uuid(),
    title: `Session ${number}${title.length ? `: ${title}` : ''}`,
    session: session.primaryKey,
  };

  const athletes = [];
  const declarations = {};
  for (const row of rows) {
    if (!row.startNumber) continue;

    const athlete = {
      protocol: protocol.uuid,
      startNumber: row.startNumber,
      entry: row.meta.entry.primaryKey,
    };
    const athletePrimaryKey = [athlete.protocol, athlete.startNumber];
    athletes.push(athlete);

    declarations[athlete.startNumber] = [];
    for (const [liftUuid, weight] of Object.entries(row.weighInDeclarations)) {
      const declaration = {
        athlete: athletePrimaryKey,
        lift: liftUuid,
        attemptNumber: 1,
        changeNumber: 0,
        weight: weight,
      };
      declarations[athlete.startNumber].push(declaration);
    }
  }

  actions.protocol.create(protocol);
  for (const athlete of athletes) {
    actions.athlete.create(athlete);

    for (const declaration of declarations[athlete.startNumber])
      actions.declaration.create(declaration);
  }
};

export default createProtocol;



// WEBPACK FOOTER //
// ./src/pages/WeighIn/createProtocol.js